// src/store/municipalStore.js
import { create } from "zustand";

const STORAGE_KEY = "municipal_requests";

const loadRequests = () => {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [];
};

const saveRequests = (requests) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(requests));
};

const seedRequests = (barrios) => {

  const now = Date.now();

  const randomBarrio = () => barrios[Math.floor(Math.random() * barrios.length)];

  return [
    {
      id: now + 1,
      barrio: "Centro La Guardia",
      tipo: "basura",
      descripcion: "Acumulación de basura en la plaza principal desde hace varios días.",
      urgencia: "media",
      lat: -17.8830,
      lng: -63.3165,
      estado: "en_proceso",
      area: "Servicios Públicos",
      areaId: 4,
      timeline: [{ state: "enviado", date: now - 86400000 }],
      respuestas: [],
      createdAt: now - 86400000,
      fotos: [],
      presidentialId: 1
    },

    {
      id: now + 2,
      barrio: "Barrio San Pedro",
      tipo: "alumbrado",
      descripcion: "Varias luminarias quemadas en la avenida principal.",
      urgencia: "alta",
      lat: -17.8920,
      lng: -63.3250,
      estado: "enviado",
      area: "Alumbrado",
      areaId: 2,
      timeline: [{ state: "enviado", date: now - 3600000 }],
      respuestas: [],
      createdAt: now - 3600000,
      fotos: [],
      presidentialId: 2
    },

    {
      id: now + 3,
      barrio: "Monte Grande",
      tipo: "caminos",
      descripcion: "La calle principal tiene muchos baches y dificulta el tránsito.",
      urgencia: "media",
      lat: -17.9200,
      lng: -63.2950,
      estado: "clasificado",
      area: "Obras Públicas",
      areaId: 1,
      timeline: [{ state: "enviado", date: now - 7200000 }],
      respuestas: [],
      createdAt: now - 7200000,
      fotos: [],
      presidentialId: 3
    },

    {
      id: now + 4,
      barrio: "Villa Simón Bolívar",
      tipo: "areas_verdes",
      descripcion: "La plaza del barrio está llena de maleza y necesita mantenimiento.",
      urgencia: "baja",
      lat: -17.8700,
      lng: -63.3450,
      estado: "resuelto",
      area: "Parques y Jardines",
      areaId: 3,
      timeline: [
        { state: "enviado", date: now - 172800000 },
        { state: "resuelto", date: now - 86400000 }
      ],
      respuestas: [],
      createdAt: now - 172800000,
      fotos: [],
      presidentialId: 4
    },

    {
      id: now + 5,
      barrio: "Naranjillo",
      tipo: "agua",
      descripcion: "Vecinos reportan baja presión de agua en las mañanas.",
      urgencia: "alta",
      lat: -17.9300,
      lng: -63.3050,
      estado: "en_proceso",
      area: "Servicios Públicos",
      areaId: 4,
      timeline: [{ state: "enviado", date: now - 14400000 }],
      respuestas: [],
      createdAt: now - 14400000,
      fotos: [],
      presidentialId: 5
    },

    {
      id: now + 6,
      barrio: "Rancho Chico",
      tipo: "caminos",
      descripcion: "Las lluvias dejaron la calle completamente inundada.",
      urgencia: "alta",
      lat: -17.8950,
      lng: -63.3350,
      estado: "enviado",
      area: "Obras Públicas",
      areaId: 1,
      timeline: [{ state: "enviado", date: now - 1800000 }],
      respuestas: [],
      createdAt: now - 1800000,
      fotos: [],
      presidentialId: 6
    },

    {
      id: now + 7,
      barrio: "Campo Verde",
      tipo: "alumbrado",
      descripcion: "Zona completamente oscura en varias calles.",
      urgencia: "media",
      lat: -17.874878,
      lng: -63.263952,
      estado: "enviado",
      area: "Alumbrado",
      areaId: 2,
      timeline: [{ state: "enviado", date: now - 5400000 }],
      respuestas: [],
      createdAt: now - 5400000,
      fotos: [],
      presidentialId: 7
    },

    {
      id: now + 8,
      barrio: "Belén",
      tipo: "basura",
      descripcion: "El camión recolector no pasa hace varios días.",
      urgencia: "media",
      lat: -17.9000,
      lng: -63.3200,
      estado: "clasificado",
      area: "Servicios Públicos",
      areaId: 4,
      timeline: [{ state: "enviado", date: now - 10800000 }],
      respuestas: [],
      createdAt: now - 10800000,
      fotos: [],
      presidentialId: 8
    }

  ];
};

export const useMunicipalStore = create((set, get) => ({

  areas: [
    { id: 1, name: "Obras Públicas", types: ["caminos","infraestructura"], color: "#0066cc", icon: "construction" },
    { id: 2, name: "Alumbrado", types: ["alumbrado"], color: "#ffd700", icon: "lightbulb" },
    { id: 3, name: "Parques y Jardines", types: ["areas_verdes"], color: "#28a745", icon: "tree" },
    { id: 4, name: "Servicios Públicos", types: ["basura","agua"], color: "#6f42c1", icon: "droplet" }
  ],

  barrios : [
    { id: 1, name: "Centro La Guardia", lat: -17.8830, lng: -63.3165 },
    { id: 2, name: "Alto La Guardia", lat: -17.8800, lng: -63.3200 },
    { id: 97, name: "Arco Iris I", lat: -17.879687, lng: -63.259145 },
    { id: 98, name: "Arco Iris II", lat: -17.879687, lng: -63.259145 },
    { id: 3, name: "Barrio 25 de Julio", lat: -17.8850, lng: -63.3100 },
    { id: 4, name: "Barrio Integración", lat: -17.8900, lng: -63.3150 },
    { id: 5, name: "Barrio La Peñita", lat: -17.8950, lng: -63.3050 },
    { id: 6, name: "Barrio San Pedro", lat: -17.8920, lng: -63.3250 },
    { id: 7, name: "Belén", lat: -17.9000, lng: -63.3200 },
    { id: 99, name: "Campo Verde", lat: -17.874878, lng: -63.263952 },
    { id: 8, name: "El Carmen", lat: -17.9100, lng: -63.3000 },
    { id: 9, name: "El Pacay", lat: -17.9150, lng: -63.3100 },
    { id: 10, name: "Monte Grande", lat: -17.9200, lng: -63.2950 },
    { id: 11, name: "Naranjillo", lat: -17.9300, lng: -63.3050 },
    { id: 12, name: "Olivera", lat: -17.9050, lng: -63.3300 },
    { id: 13, name: "Rancho Chico", lat: -17.8950, lng: -63.3350 },
    { id: 14, name: "San Carlos", lat: -17.8800, lng: -63.3000 },
    { id: 15, name: "San Juan", lat: -17.8700, lng: -63.3100 },
    { id: 16, name: "San Miguel del Rosario", lat: -17.8600, lng: -63.3200 },
    { id: 17, name: "Totorales", lat: -17.8750, lng: -63.3300 },
    { id: 18, name: "Triunfo", lat: -17.9000, lng: -63.2900 },
    { id: 19, name: "Villa Rosario", lat: -17.8850, lng: -63.3400 },
    { id: 20, name: "Villa San Carlos", lat: -17.8900, lng: -63.3500 },
    { id: 21, name: "Villa Simón Bolívar", lat: -17.8700, lng: -63.3450 },
    { id: 22, name: "Basilio", lat: -17.9500, lng: -63.2800 },
    { id: 23, name: "Cañaveral 1", lat: -17.9400, lng: -63.2700 },
    { id: 24, name: "Cañaveral 2", lat: -17.9450, lng: -63.2650 },
    { id: 25, name: "La Melea", lat: -17.9550, lng: -63.2600 },
    { id: 26, name: "Nueva Esperanza", lat: -17.9650, lng: -63.2500 },
    { id: 27, name: "Pedro Lorenzo", lat: -17.9700, lng: -63.2400 },
    { id: 28, name: "San José", lat: -17.9800, lng: -63.2300 },
    { id: 29, name: "San Miguel del Monte Grande", lat: -17.9900, lng: -63.2200 },
    { id: 30, name: "Tupac Katari", lat: -17.9600, lng: -63.2750 },
    { id: 31, name: "Vallecito Tacuarembó", lat: -17.9500, lng: -63.2900 },
    { id: 32, name: "Villa Victoria", lat: -18.0150, lng: -63.0290 }
    ],

  requests: loadRequests().length ? loadRequests() : seedRequests([
    { name: "Centro La Guardia" },
    { name: "Barrio San Pedro" },
    { name: "Monte Grande" },
    { name: "Villa Simón Bolívar" },
    { name: "Naranjillo" },
    { name: "Rancho Chico" },
    { name: "Campo Verde" },
    { name: "Belén" }
  ]),

  filterState: "todos",
  filterArea: "todos",
  filterBarrio: "todos",

  createRequest: (data) => {

    const area = get().areas.find(a =>
      a.types.includes(data.tipo)
    );

    const newRequest = {
      id: Date.now(),
      barrio: data.barrio,
      presidente: data.presidente,
      tipo: data.tipo,
      descripcion: data.descripcion,
      urgencia: data.urgencia,
      lat: data.lat || data.barrio.lat,
      lng: data.lng || data.barrio.lng,
      estado: "enviado",
      area: area?.name || "pendiente",
      areaId: area?.id,
      timeline: [
        { state: "enviado", date: Date.now() }
      ],
      respuestas: [],
      createdAt: Date.now(),
      fotos: data.fotos || [],
      presidentialId: data.presidentialId
    };

    const updated = [...get().requests, newRequest];
    saveRequests(updated);
    set({ requests: updated });

  },

  updateState: (id, state) => {

    const updated = get().requests.map(r => {

      if (r.id !== id) return r;

      return {
        ...r,
        estado: state,
        timeline: [
          ...r.timeline,
          { state, date: Date.now() }
        ]
      };

    });

    saveRequests(updated);
    set({ requests: updated });

  },

  addResponse: (id, message) => {

    const updated = get().requests.map(r => {

      if (r.id !== id) return r;

      return {
        ...r,
        respuestas: [
          ...r.respuestas,
          {
            id: Date.now(),
            message,
            date: Date.now(),
            author: "Equipo Municipal"
          }
        ]
      };

    });

    saveRequests(updated);
    set({ requests: updated });

  },

  setFilters: (filterState, filterArea, filterBarrio) => 
    set({ filterState, filterArea, filterBarrio }),

  getStats: () => {

    const requests = get().requests;
    const byState = {};
    const byArea = {};
    const byBarrio = {};
    const byUrgency = {};

    requests.forEach(r => {
      byState[r.estado] = (byState[r.estado] || 0) + 1;
      byArea[r.area] = (byArea[r.area] || 0) + 1;
      byBarrio[r.barrio] = (byBarrio[r.barrio] || 0) + 1;
      byUrgency[r.urgencia] = (byUrgency[r.urgencia] || 0) + 1;
    });

    return {
      total: requests.length,
      byState,
      byArea,
      byBarrio,
      byUrgency,
      resueltas: byState["resuelto"] || 0,
      enProceso: byState["en_proceso"] || 0,
      promedio: requests.length > 0 
        ? Math.round((Date.now() - Math.min(...requests.map(r => r.createdAt))) / requests.length / 1000 / 60) 
        : 0
    };

  },

  getFilteredRequests: () => {
    const { requests, filterState, filterArea, filterBarrio } = get();
    
    return requests.filter(r => {
      const stateMatch = filterState === "todos" || r.estado === filterState;
      const areaMatch = filterArea === "todos" || r.area === filterArea;
      const barrioMatch = filterBarrio === "todos" || r.barrio === filterBarrio;
      return stateMatch && areaMatch && barrioMatch;
    });
  }

}));